import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'react-css-themr';
import { isControlUrl } from '../../utils/url';

import LoginPage from '../../components/pages/LoginPage';
import ForgotPasswordPage from '../../components/pages/ForgotPasswordPage';
import ResetPasswordPage from '../../components/pages/ResetPasswordPage';
import { TITLE, TITLE_CONTROL } from '../../config';
import ACSTheme from '../../theme';
import styles from './App.scss';
import RegistrationPage from '../../components/pages/RegistrationPage';

const isControl = isControlUrl();

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entries: [],
      meta: {},
      email: '',
      carouselContainer: {},
    };
    this.onEmailBlur = this.onEmailBlur.bind(this);
  }

  onEmailBlur(event) {
    const updatedEmail = event.target.value;
    this.setState({
      ...this.state,
      email: updatedEmail,
    });
  }

  render() {
    return (
      <ThemeProvider theme={ACSTheme}>
        <Router>
          <div className={`${styles.background}`}>
            <Helmet
              titleTemplate={`%s - ${isControl ? TITLE_CONTROL : TITLE}`}
            />
            <div className={`row row--mx-0 ${styles.viewport}`}>
              <Switch>
                <Route
                  path="/login"
                  exact
                  render={props => (
                    <LoginPage
                      onEmailBlur={this.onEmailBlur}
                      {...props}
                      {...this.state}
                    />
                  )}
                />
                <Route
                  path="/register"
                  exact
                  render={() => <RegistrationPage />}
                />
                <Route
                  path="/forgot-password"
                  exact
                  render={props => (
                    <ForgotPasswordPage {...props} {...this.state} />
                  )}
                />
                <Route
                  path="/reset-password"
                  exact
                  render={props => (
                    <ResetPasswordPage {...props} {...this.state} />
                  )}
                />
                <Redirect to="/login" />
              </Switch>
            </div>
          </div>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/client/src/apps/login/App.js